import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/Login.vue'
import Index from '../pages/Index.vue'
import ProductQuery from '../layouts/product/ProductQuery.vue'
import Welcome from '../layouts/Welcome.vue'
import ProductIndex from '../layouts/product/ProductIndex.vue'
import AddProduct from '../layouts/product/AddProduct.vue'
import ViewProduct from '../layouts/product/ViewProduct.vue'
import CustomerQuery from '../layouts/customer/CustomerQuery.vue'
import CustomerIndex from '../layouts/customer/CustomerIndex.vue'
import ViewCustomer from '../layouts/customer/ViewCustomer.vue'
import UserQuery from "../layouts/user/UserQuery.vue"
import UserIndex from "../layouts/user/UserIndex.vue"
import ActivePassword from "../pages/ActivePassword.vue"
import ForgetPassword from "../pages/ForgetPassword.vue"
import SignFailPage from "../pages/SignFailPage.vue"
import ProductNoticeIndex from "../layouts/productnotice/ProductNoticeIndex.vue"
import ProductNoticeQuery from "../layouts/productnotice/ProductNoticeQuery.vue"
import AddProductNotice from "../layouts/productnotice/AddProductNotice.vue"
import EditProductNotice from "../layouts/productnotice/EditProductNotice.vue"
import CustomerOrderIndex from "../layouts/customerorder/CustomerOrderIndex.vue";
import CustomerOrderQuery from "../layouts/customerorder/CustomerOrderQuery.vue";
import OrgConfig from "../layouts/orgconfig/OrgConfig.vue"
import RegisterPanel from "../pages/RegisterPanel.vue";


Vue.use(Router)

const routes = [
  {
    name: 'login',
    path: '/login',
    alias: '/',
    component: Login
  },
	{
		name:"serverexception",
		path:"/serverexception",
		component:SignFailPage,
		meta:{requireLogin:false,keepAlive:false}
	},
	{
		name:"active",
		path:"/active",
		component:ActivePassword
	},
	{
		name:"forgetpassword",
		path:"/forgetpassword",
		component:ForgetPassword
	},
	{
		name:"register",
		path:"/register",
		component:RegisterPanel
	},
  {
    name: 'index',
    path: '/index',
    component: Index,
    children: [
			{
				name: 'welcome',
				path: '',
				component: Welcome
			},
      {
        name: 'product',
        path: 'product',
        component: ProductIndex,
				children: [
					{
						name: 'productquery',
						path: '',
						component: ProductQuery
					},
					{
						name: 'productadd',
						path: 'add',
						component: AddProduct
					},
					{
						name: 'productview',
						path: 'view',
						component: ViewProduct
					}
				]
      },
      {
        name: 'customer',
        path: 'customer',
        component: CustomerIndex,
				children: [
					{
						name: 'customerquery',
						path: '',
						component: CustomerQuery
					},
					{
						name: 'customerview',
						path: 'view',
						component: ViewCustomer
					}
				]
      },
			{
				name: 'customerorder',
				path: 'customerorder',
				component: CustomerOrderIndex,
				children: [
					{
						name: 'customerorderquery',
						path: '',
						component: CustomerOrderQuery
					}
				]
			},
			{
				name: 'user',
				path: 'user',
				component:UserIndex,
				children: [
					{
						name:"userquery",
						path:"",
						component:UserQuery
					}
				]
			},
			{
				name:"orgconfig",
				path:"orgconfig",
				component:OrgConfig
			},
			{
				name:"productnotice",
				path:"productnotice",
				component:ProductNoticeIndex,
				children:[
					{
						name:"productnoticequery",
						path:"",
						component:ProductNoticeQuery
					},
					{
						name:"addproductnotice",
						path:"add",
						component:AddProductNotice
					},
					{
						name:"editproductnotice",
						path:"edit:productnoticeid",
						component:EditProductNotice
					}
				]
			}
    ]
  }
]

export default new Router({
  routes: routes,
})



// WEBPACK FOOTER //
// ./src/router/index.js